import appPropsReducer from "./appPropsReducer";
import authReducer from "./authReducer";
import { combineReducers, createStore, compose, applyMiddleware } from "redux"; //add redux-thunk, compose, applyMiddleware
import reduxThunk from "redux-thunk"; //add redux-thunk
import { IAuthStore } from "./authReducer/types";
import { IAppPropsStore } from "./appPropsReducer/types";
import { IAccountsStore } from "./accountsReducer/types";
import accountsReducer from "./accountsReducer";

export interface IRootStore {
  appPropsStore: IAppPropsStore;
  authStore: IAuthStore;
  accountsStore: IAccountsStore;
}

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
  }
}
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; //Add ReduxDev Tools
const store = createStore(
  combineReducers({
    appPropsStore: appPropsReducer,
    authStore: authReducer,
    accountsStore: accountsReducer,
  }),
  composeEnhancers(applyMiddleware(reduxThunk))
);

export default store;
